export default __webpack_public_path__ + "static/media/project_bullground_2.75378eb9.png";